import { useId } from 'react';
import { useFormContext } from 'react-hook-form';
import type { SendFormValues } from './formSchema';

const TITLE_MAX = 40;
const CONTENT_MAX = 300;

/** 좌(고객) · 우(반장님·거래처) 영역에 각각 둔다 — 영역마다 다른 필드를 쓴다(기본: title · content). */
export function MessageForm({
  titleName = 'title',
  contentName = 'content',
}: {
  titleName?: 'title' | 'customerTitle';
  contentName?: 'content' | 'customerContent';
} = {}) {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<SendFormValues>();
  const idPrefix = useId();

  const titleValue = watch(titleName) ?? '';
  const contentValue = watch(contentName) ?? '';
  const titleError = errors[titleName];
  const contentError = errors[contentName];

  return (
    <div className="space-y-5">
      {/* 제목 */}
      <div>
        <label htmlFor={`${idPrefix}-title`} className="text-xs text-text-secondary">제목</label>
        <input
          id={`${idPrefix}-title`}
          type="text"
          maxLength={TITLE_MAX}
          placeholder="제목을 입력해 주세요"
          {...register(titleName)}
          className={`mt-1.5 w-full rounded-xl border px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-primary-400 ${
            titleError ? 'border-error' : 'border-border-default'
          }`}
        />
        <div className="mt-1 flex items-center justify-between">
          {titleError ? (
            <p className="text-xs text-error">{titleError.message}</p>
          ) : (
            <span />
          )}
          <span className="text-xs text-text-secondary">
            {titleValue.length} / {TITLE_MAX}
          </span>
        </div>
      </div>

      {/* 내용 */}
      <div>
        <label htmlFor={`${idPrefix}-content`} className="text-xs text-text-secondary">내용</label>
        <textarea
          id={`${idPrefix}-content`}
          rows={4}
          maxLength={CONTENT_MAX}
          placeholder="내용을 입력해 주세요"
          {...register(contentName)}
          className={`mt-1.5 w-full resize-none rounded-xl border px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-primary-400 ${
            contentError ? 'border-error' : 'border-border-default'
          }`}
        />
        <div className="flex items-center justify-between">
          {contentError ? (
            <p className="text-xs text-error">{contentError.message}</p>
          ) : (
            <span />
          )}
          <span className="text-xs text-text-secondary">
            {contentValue.length} / {CONTENT_MAX}
          </span>
        </div>
      </div>
    </div>
  );
}
